/**
 * AdToolsFooterLinks — the footer's "Ad tools" row: the ad pages other than
 * the ad generator (which has its own footer link, AdGeneratorFooterLink),
 * each named with its localized h1, in the page's language
 * (shared/adGeneratorLink.ts). Rendered in the homepage footer (LandingV2)
 * and the CreativeLandingShell footer; the homepage crawler HTML carries the
 * same row (renderHomepageFooterLink in server/_core/seo.ts). Renders nothing
 * on the ad pages, which link each other in "More ad tools". Real <a href>s
 * that navigate client-side on a plain click.
 */
import type { MouseEvent } from "react";
import { useLanguageRouter } from "@/hooks/useLanguageRouter";
import { AD_PAGE_PATHS, adToolsFooterRow } from "@shared/adGeneratorLink";

export default function AdToolsFooterLinks() {
  const { currentLang, pathWithoutLang, withLanguagePath, navigate } =
    useLanguageRouter();
  if (AD_PAGE_PATHS.includes(pathWithoutLang.split(/[?#]/)[0]!.replace(/\/$/, "")))
    return null;
  const { heading, links } = adToolsFooterRow(currentLang);

  const onClick = (path: string) => (e: MouseEvent<HTMLAnchorElement>) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) {
      return;
    }
    e.preventDefault();
    navigate(path);
  };

  return (
    <nav className="ad-tools" aria-label={heading}>
      <span className="mono">{heading}</span>
      {links.map(({ path, label }) => (
        <a key={path} href={withLanguagePath(path)} onClick={onClick(path)}>
          {label}
        </a>
      ))}
    </nav>
  );
}
